import { PersonCard } from "../../PersonCard";
import styles from "./styles.module.scss";

export const PersonBlockDesktop: React.FC = () => {
  return (
    <div className={styles.root}>
      <PersonCard />
    </div>
  );
};
